export default __webpack_public_path__ + "static/media/poki@3x.1fbfb71a.png";